import $ from "jquery";

$(document).ready(function () {
    let selectedFilters = [];


    const urlParams = new URLSearchParams(window.location.search);
    const productName = urlParams.get('product-name');

    if (productName) {
        selectedFilters.push({
            id: productName,
            type: 'profile',
            text: productName
        });
        updateSelectedFilters();
        updateFilterButtons();
        applyFilters();
        toggleFileTypeFilter();
    }


    initializeFilterButtons();

    $(document).on("keypress", ".js-searchresources-filter", function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
            $(".js-searchresources-filter-button").click();
        }
    });

    $(document).on('click', '.js-toggle-download-option', function (e) {
        e.preventDefault();
        $(this).closest(".born-resource-centre-item").toggleClass("download-options-active");
    });

    function closeFilterButtons() {
        const resourcefilterButton = document.querySelectorAll(".js-toggle-filter-nav");
        resourcefilterButton.forEach(function (item) {
            item.classList.remove("is-active");
        });
    }

    $(document).on("click", ".js-filter-item-button", function () {
        const itemSelect = $(this).data("id");
        const itemType = $(this).data("type");
        const itemText = $(this).data("text");

        if(!selectedFilters.includes(itemSelect))
        {
            selectedFilters.push({
                id: itemSelect,
                type: itemType,
                text: itemText
            });
        }

        updateSelectedFilters();
        updateFilterButtons();
        applyFilters();
        closeFilterButtons();
        toggleFileTypeFilter();
    });

    $(document).on("click", ".js-selected-filter", function () {
        const item = $(this).data("id");
        selectedFilters = selectedFilters.filter(x=>x.id !== item);
        updateSelectedFilters();
        updateFilterButtons();
        applyFilters();
        toggleFileTypeFilter();
    });

    $(document).on("click", ".js-searchresources-filter-button", function () {
        applyFilters();
        toggleFileTypeFilter();
    });

    $(document).on("click", ".js-filter-item-button[data-id='CAD File']", function () {
        toggleFileTypeFilter();
    });

    function applyFilters() {
        const searchText = $(".js-searchresources-filter").val();
        $.ajax({
            url: "/umbraco/surface/ResourceCentre/TechnicalDocumentsListingWithFilters",
            type: "GET",
            data: {
                id: $('.js-resource-listing').data('id'),
                filters: JSON.stringify(selectedFilters),
                searchText: searchText
            },
            success: function (response) {
                $('.js-view-resource-centre-result').replaceWith(response);
            }
        });
    }

    function updateSelectedFilters() {
        const selectedFiltersElement = $(".js-selected-filters");
        selectedFiltersElement.empty();

        selectedFilters.forEach(function (item) {
            $(".js-selected-filters").append(
                `<button class="born-resource-centre-filters-button js-selected-filter" data-id="${item.id}">
                ${item.text} <span class="cross">×</span>
             </button>`
            );
        });
    }

    function updateFilterButtons(){
        const filterListButtons = $(".js-filter-item").toArray();

        const toHide = filterListButtons.filter(function(element){
            const id = $(element).data("id");
            return selectedFilters.some(v=>v.id === id);
        });

        console.log(toHide);
        toHide.forEach(function (item) {
            $(item).hide();
        });

        const toShow = filterListButtons.filter(function(element){
            const id = $(element).data("id");
            return !selectedFilters.some(v=>v.id === id);
        });
        toShow.forEach(function (item) {
            $(item).show();
        });
    }

    function initializeFilterButtons(){
        const resourcefilterButton = document.querySelectorAll(".js-toggle-filter-nav");
        for (var i = 0; i < resourcefilterButton.length; i++) {
            resourcefilterButton[i].addEventListener("click", function(e) {
                e.preventDefault();
                this.classList.toggle("is-active");
            });
        }
    }

    function toggleFileTypeFilter() {
        const isCADFileSelected = selectedFilters.some(filter => filter.id === 'CAD File');
        const otherFiltersSelected = selectedFilters.length > 1;

        if (isCADFileSelected && !otherFiltersSelected) {
            $('.born-resource-centre-filters__item').eq(1).hide();
        } else {
            $('.born-resource-centre-filters__item').eq(1).show();
        }
    }
});
